export class saveMaintenence{  
    VID : any;   
    contract: string;
    VulRecordStatus : string;
    Validate : any;
    LastUpdatedBy : any;
}